import { captureException, setTag } from '@sentry/react';
import axios from 'axios';
import ErrorWithCause from '../../helpers/ErrorWithCause';
import { API_BASE_URL, SYMFONY_API_BASE_URL } from '@config/apiConfig';
export async function beginPaypalDeposit(request, isUsePaymentMicroserviceEnabled, correlationId) {
    var _a, _b;
    const requestPath = isUsePaymentMicroserviceEnabled
        ? `${API_BASE_URL}/payments/payment-deposit/paypal`
        : `${SYMFONY_API_BASE_URL}/api/deposit/paypal/v1`;
    try {
        const headers = {
            'X-Correlation-ID': correlationId,
        };
        const response = await axios.post(requestPath, {
            ...request,
            coins: isUsePaymentMicroserviceEnabled && request.coins === null ? undefined : request.coins,
        }, { headers });
        return response.data;
    }
    catch (error) {
        // Parse Payment Microservice error format where details is a JSON string
        if (axios.isAxiosError(error) && ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details)) {
            try {
                const parsedDetails = JSON.parse(error.response.data.details);
                // Attach parsed details to the error response for easier access
                error.response.data = { ...error.response.data, ...parsedDetails };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            }
            catch (_parseError) {
                // If parsing fails, keep the original error format
            }
        }
        const e = new ErrorWithCause(error);
        // Set Sentry tags for better searchability
        setTag('paypalOrderId', request.paypalOrderId);
        setTag('correlationId', correlationId);
        captureException(e, {
            extra: {
                requestMethod: 'POST',
                requestPath,
                function: 'beginPaypalDeposit',
                paypalOrderId: request.paypalOrderId,
                correlationId,
                isNetworkError: axios.isAxiosError(error) && !error.response,
            },
        });
        // If the order couldn't be recorded, throw an error and the process should fail.
        throw e;
    }
}
export default beginPaypalDeposit;
